import React, { useState, useEffect } from "react";
import * as yup from 'yup'
import axios from 'axios'
import {useHistory} from 'react-router-dom'
import { axiosWithAuth } from "./axiosWithAuth";
import styled from 'styled-components'
// const schema = yup.object().shape({
//     event_name: yup.string().required(`An event name is required.`),
//     date: yup.string().required(`An event date is required.`),
//     time: yup.string().required(`An event time is required.`),
//     description: yup.string().required(`An event description is required.`),

// })
const StyledCard = styled.div`
color: white;

form{
  display:flex;
  flex-direction:column;
}
button {
  margin: 1% 0;
  box-shadow: inset 0px 1px 0px 0px #bee2f9;
  background: linear-gradient(to bottom, #63b8ee 5%, #468ccf 100%);
  background-color: #63b8ee;
  border-radius: 6px;
  border: 1px solid #3866a3;
  display: inline-block;
  cursor: pointer;
  color: #14396a;
  font-family: Arial;
  font-size: 15px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #7cacde;
  &:hover {
    background: linear-gradient(to bottom, #468ccf 5%, #63b8ee 100%);
    background-color: #468ccf;
  }
  &:active {
    position: relative;
    top: 1px;
  }
}
`

const initialFormValues = {
    event_name: '',
    date: '',
    time:'',
    description: '',
    organizer_id: localStorage.getItem(' organizer_id')
  }
// const initialErrors = {
//   event_name: '',
//   date: '',
//   time:'',
//   description: '',
//   }
 function CardMaker(props){
    const [form, setForm] = useState(initialFormValues)
    const [cards, setCards] = useState([])
    // const [disabled, setDisabled] = useState(true)
    // const [errors, setErrors] = useState(initialErrors)
    const history = useHistory()
    // const setFormErrors = (name, value) => {
    //     yup
    //     .reach(schema, name)
    //     .validate(value)
    //     .then(() => setErrors({...errors, [name]:''}))
    //     .catch((err) => {
    //       setErrors({...errors, [name]:err.errors[0]})
    //     })
    //     }

        // useEffect(() => {
        // schema.isValid(form).then((valid) => setDisabled(!valid))
        // }, [form])


        const change = (evt) => {
          const {value, name} = evt.target;
          // setFormErrors(name, value);
          setForm({...form, [name]: value})
        }

        const submit = (evt) => {
          evt.preventDefault()
          const newCard = { event_name: form.event_name.trim(), date: form.date.trim(), time: form.time.trim(), description: form.description.trim(), organizer_id: localStorage.getItem('organizer_id, id')
        }

          setForm(initialFormValues)
          postEvent(newCard)

          history.push('/home')
        }


        const postEvent = (newCard) => {
          axiosWithAuth()
          .post('/events', newCard)
          .then(res => {
             console.log(res)
             history.push('/home')
            //  setCards([res.data.event])
          })
          .catch(err => console.log(err))
        }

    return(
        <StyledCard>
            <form onSubmit={submit}>
         <label><h4>Event:</h4>
         <input type="text" name="event_name" value={form.event} onChange={change}/>
         </label>
         <label > <h4>Date:</h4>
         <input type="text" name="date" value={form.date} onChange={change}/>
         </label>
         <label> <h4>Time:</h4>
         <input type="text" name="time" value={form.time} onChange={change}/>
         </label>
         <label> <h4>Description:</h4>
         <input type="text" name="description" value={form.description} onChange={change}/>
         </label>
         <label>
             <button className="cardBtn">Post!</button>
         </label>
        </form>
        </StyledCard>
    )
}

export default CardMaker